import { BusinessAreaSettings, businessAreaSettingsAll, BusinessAreaCode } from "../constants";

export const businessAreaSettings = ():BusinessAreaSettings=> {  
  const businessAreaCode = process.env.REACT_APP_BUSINESS_AREA as BusinessAreaCode;
  return businessAreaSettingsAll[businessAreaCode] ? businessAreaSettingsAll[businessAreaCode] : businessAreaSettingsAll["default"];
}